export const AnalysisIcon = () => (
  <svg
    width={46}
    height={46}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_599_17646)">
      <path
        d="M40.6394 12.8199V35.2599C40.6394 38.4299 38.0694 40.9899 34.9094 40.9899H11.0894C7.92937 40.9899 5.35938 38.4299 5.35938 35.2599V28.7499C5.35938 25.5899 7.92937 23.0199 11.0894 23.0199H15.1894V22.1199C15.1894 18.8799 17.8194 16.2499 21.0494 16.2499H24.9994V13.0999C24.9994 8.93993 28.1394 5.29993 32.2894 5.02993C36.8294 4.72993 40.6394 8.32993 40.6394 12.8299V12.8199Z"
        fill="url(#paint0_linear_599_17646)"
      />
      <path
        d="M15.2708 26.96H11.1008C10.1008 26.96 9.30078 27.77 9.30078 28.76V35.27C9.30078 36.27 10.1108 37.07 11.1008 37.07H15.2708C16.2708 37.07 17.0708 36.26 17.0708 35.27V28.76C17.0708 27.76 16.2608 26.96 15.2708 26.96Z"
        fill="url(#paint1_linear_599_17646)"
      />
      <path
        d="M24.9491 20.1799H21.0591C19.9891 20.1799 19.1191 21.0499 19.1191 22.1199V35.1299C19.1191 36.1999 19.9891 37.0699 21.0591 37.0699H24.9491C26.0191 37.0699 26.8891 36.1999 26.8891 35.1299V22.1199C26.8891 21.0499 26.0191 20.1799 24.9491 20.1799Z"
        fill="url(#paint2_linear_599_17646)"
      />
      <path
        d="M32.8292 8.92993C34.9792 8.92993 36.7192 10.6799 36.7192 12.8199V35.2599C36.7192 36.2599 35.9192 37.0699 34.9192 37.0699H30.7492C29.7492 37.0699 28.9492 36.2699 28.9492 35.2599V12.8199C28.9492 10.6699 30.6992 8.92993 32.8392 8.92993H32.8292Z"
        fill="url(#paint3_linear_599_17646)"
      />
      <path
        opacity={0.62}
        d="M32.8302 15.6199C31.2602 15.6199 29.9902 14.3399 29.9902 12.7799C29.9902 11.2199 31.2602 9.93994 32.8302 9.93994C34.4002 9.93994 35.6702 11.2199 35.6702 12.7799C35.6702 14.3399 34.4002 15.6199 32.8302 15.6199Z"
        fill="url(#paint4_linear_599_17646)"
      />
      <path
        d="M32.8294 15.0001C34.0594 15.0001 35.0494 14.0101 35.0494 12.7801C35.0494 11.5501 34.0594 10.5601 32.8294 10.5601C31.5994 10.5601 30.6094 11.5501 30.6094 12.7801C30.6094 14.0101 31.5994 15.0001 32.8294 15.0001Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_599_17646"
        x1={18.2894}
        y1={40.9599}
        x2={36.0994}
        y2={7.08993}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FF00" />
        <stop offset={0.52} stopColor="#00FF00" stopOpacity={0.89} />
        <stop offset={1} stopColor="#99FF00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_599_17646"
        x1={12}
        y1={38.5}
        x2={17}
        y2={18}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#017901" />
        <stop offset={1} stopColor="#00BE00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_599_17646"
        x1={23}
        y1={38.5}
        x2={23}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#017901" />
        <stop offset={1} stopColor="#00BE00" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_599_17646"
        x1={29}
        y1={37}
        x2={34.5}
        y2={11.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#017901" />
        <stop offset={1} stopColor="#00BE00" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_599_17646"
        x1={32.8302}
        y1={10.1499}
        x2={32.8302}
        y2={15.9099}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D1FD00" stopOpacity={0.8} />
        <stop offset={1} stopColor="#DEFD92" stopOpacity={0.5} />
      </linearGradient>
      <clipPath id="clip0_599_17646">
        <rect width={46} height={46} fill="white" />
      </clipPath>
    </defs>
  </svg>
)
